import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    count: 0,
    global: {
      apple_link: "https://apps.apple.com/fr/app/id1484937026",
      google_link:
        "https://play.google.com/store/apps/details?id=com.idtroc.idkids",
      download_apple: "téléchargez sur l'app store",
      download_google: "téléchargez sur Google Play store"
    }
  },
  mutations: {
    incrementCounter(state, payload) {
      state.count += payload;
    }
  },
  actions: {
    inrementAction({ commit }, payload) {
      commit("incrementCounter", payload);
    }
  },
  getters: {
    counter(state) {
      return state.count;
    },
    global(state) {
      return state.global;
    },
    isMobile(state) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    isAndroid(state) {
      if (/Android/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
    isIos(state) {
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js